export const requestLimitConstant = {
    UPDATE: "REQUEST_LIMIT_UPDATE",
    DETAILS: "REQUEST_LIMIT_DETAILS",
    REQUEST: "REQUEST_LIMIT_REQUEST",
    FAILED: "REQUEST_LIMIT_FAILED",
};